import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';
import Sortable from 'sortablejs';

/**
 * List sortable - drag the lists of the board settings to reorder them.
 * On drop it PATCHes the list's move endpoint with the id of the list it now sits in front of.
 * If the server refuses the move, the page is reloaded so it shows the real order again.
 * Targets: item - a row, carries data-list-id; the element with data-handle starts the drag
 * Values: url-template (String) - move URL containing `:id`
 * @example
 * <ul data-controller="list-sortable" data-list-sortable-url-template-value="/boards/1/lists/:id/move">
 *   <li data-list-sortable-target="item" data-list-id="7"><span data-handle>…</span></li>
 * </ul>
 */
export default class extends Controller {
  static targets = ['item'];
  static values = { urlTemplate: String };

  connect () {
    this.sortable = Sortable.create(this.element, {
      draggable: '[data-list-id]',
      handle: '[data-handle]',
      animation: 150,
      // Rows hold inputs and buttons: Sortable drives the drag instead of the native HTML5 one
      forceFallback: true,
      fallbackTolerance: 4,
      ghostClass: 'is-ghost',
      chosenClass: 'is-chosen',
      dragClass: 'is-dragging',
      onEnd: (event) => this.move(event)
    });
  }

  disconnect () {
    this.sortable?.destroy();
  }

  async move (event) {
    const { item, oldIndex, newIndex } = event;
    if (oldIndex === newIndex) return;

    const body = new FormData();
    body.append('before_id', item.nextElementSibling?.dataset.listId || '');

    const response = await patch(this.urlTemplateValue.replace(':id', item.dataset.listId), { body });
    if (!response.ok) window.Turbo.visit(window.location.href, { action: 'replace' });
  }
}
